import { GraphSchema } from '@ta/server';

import { Address } from '../../adresses/dto/address';
import { Estate } from '../../estates/dto/estate';
import { CompanyMember } from './company-member';
import { CompanyRevenue } from './revenue';

export interface Company {
  id: string;
  name: string;
  description: string;
  registrationNumber: string;
  vatNumber: string;
  website: string;
  email: string;
  phoneNumber: string;
  logo: string;
  addressId: string;
  status: number;
  revenue: CompanyRevenue;
  createdDate: string;
  updatedDate: string;
  deleted: boolean;
  address?: Address;
  members?: CompanyMember[];
  memberCount?: number;
  estates?: Estate[];
  globalNote?: number;
  trustScore?: number;
}

export const companyBrutProps: (keyof Company)[] = [
  'id',
  'name',
  'description',
  'registrationNumber',
  'vatNumber',
  'website',
  'email',
  'phoneNumber',
  'logo',
  'addressId',
  'status',
  'revenue',
  'createdDate',
  'updatedDate',
  'address',
  'members',
  'memberCount',
  'estates',
  'globalNote',
  'trustScore',
];

export const companyProps = new GraphSchema<Company>(companyBrutProps);
